import React from 'react';
import { Navigate } from 'react-router-dom';

interface RoleGuardProps {
  children: React.ReactNode;
  requiredRole: 'superadmin' | 'admin';
}

const RoleGuard: React.FC<RoleGuardProps> = ({ children, requiredRole }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const userRole = localStorage.getItem('userRole') as 'superadmin' | 'admin' | null;

  // Check authentication
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Check role permission
  if (requiredRole === 'superadmin' && userRole !== 'superadmin') {
    // Only super admin can access super admin routes
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (requiredRole === 'admin' && userRole === 'superadmin') {
    // Super admin trying to access admin panel, redirect to super admin
    return <Navigate to="/super-admin/profile" replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;

